import React, { useEffect, useState } from 'react';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Helmet } from 'react-helmet';
import Testimonials from '../../components/Home/Testimonials';
import TeamMember from '../../components/Home/TeamMember';
import api from '../../services/api';

const getImageUrl = (imagePath) => {
  if (!imagePath) return '';

  if (/^https?:\/\//i.test(imagePath)) {
    return imagePath;
  }

  return `https://www.businessmateworkflow.in/${imagePath.replace(/^\/+/, '')}`;
};
const About = () => {
  const [aboutContent, setAboutContent] = useState(null);
  const [testimonial] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const { data } = await api.get('/about');
        setAboutContent(data.data);
        console.log(data.data);
console.log(typeof data.data.about_business);
console.log(data.data.about_business);
      } catch (err) {
        console.error('Failed to load about page data', err);
      } finally {
        setLoading(false);
      }
    };
    fetchAboutData();
  }, []);

  const features = [
    { icon: 'la la-thumbs-up', title: 'Valuable Ideas', description: aboutContent?.about_valuable_ideas || 'Loading...' },
    { icon: 'la la-bar-chart', title: 'Industry Experience', description: aboutContent?.about_industry_experience || 'Loading...' },
    { icon: 'la la-money', title: 'Budget Friendly', description: aboutContent?.about_budget_friendly || 'Loading...' },
    { icon: 'la la-pencil-square', title: 'Investment Planning', description: aboutContent?.about_investment_planning || 'Loading...' },
    { icon: 'la la-level-up', title: 'Business Growth', description: aboutContent?.about_business_growth || 'Loading...' },
    { icon: 'la la-lightbulb-o', title: 'Financial Planning', description: aboutContent?.about_financial_planning || 'Loading...' },
  ];

  const skills = [
    { name: 'Business', percentage: aboutContent?.about_business_sk || 70 },
    { name: 'Corporate', percentage: aboutContent?.about_corporate || 85 },
    { name: 'Finance', percentage: aboutContent?.about_finance || 90 },
    { name: 'Strategy', percentage: aboutContent?.about_strategy || 75 },
  ];

if (loading) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center", // horizontal center
        alignItems: "center",     // vertical center
        height: "100vh",          // full viewport height
        width: "100%",            // full width
        backgroundColor: "#fff",  // optional
      }}
    >
      <img
        src="http://localhost:3000/static/media/logo.25b2a68e446a05e3a861.webp"
        alt="Loading..."
      />
    </div>
  );
}

  if (!aboutContent) return <div>Error loading about content</div>;

  return (
    <main className="home-page">
   <Helmet>
  {/* Page Title */}
  <title>
    About Us | Startup Business Partners
  </title>

  {/* SEO Description */}
  <meta
    name="description"
    content="Business consulting, startup growth, financial planning, and investment solutions."
  />

  {/* SEO Keywords */}
  <meta
    name="keywords"
    content="startup consulting, business growth, finance, investment planning"
  />

  {/* Canonical URL */}
  <link
    rel="canonical"
    href="https://yourdomain.com/about"
  />

  {/* Open Graph (Facebook/LinkedIn) */}
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="About Startup Business Partners"
  />
  <meta
    property="og:description"
    content="Business consulting and startup growth solutions."
  />
  <meta
    property="og:image"
    content="https://snmtechnologies.in/startup/img/about-hero-img.jpg"
  />
  <meta
    property="og:url"
    content="https://www.businessmateworkflow.in/about"
  />


</Helmet>

      <Navbar />
            
             {/* ================================================
          BREADCRUMB
      ================================================= */}
     <section
  style={{
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    padding: '40px 0',
    color: '#fff'
  }}
>
  <div className="container text-center">

    <h1
      style={{
        fontSize: 42,
        fontWeight: 700,
        marginBottom: 18,
             color:'#fff'
      }}
    >
About Us
    </h1>

    <p
      style={{
        fontSize: 19,
        opacity: 0.9,
        maxWidth: 850,
        margin: '0 auto 15px',
        lineHeight: 1.7
      }}
    >
   Learn more about our plans, services, and the team behind them. Discover how we’re committed to providing flexible, reliable, and value-driven solutions to meet your needs.
    </p>


  </div>
</section>

{/* Hero Section */}
<section className="p-top-50 p-bottom-15">
  <div className="icon-boxes icon-box--four">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 col-md-6">
          <div className="about" style={{ marginTop: '30px' }}>
            <h2>The Best way to</h2>
            <h2 style={{ color: 'rgb(6, 181, 144)' }}>
              Grow your Business
            </h2>

            <div
              className="post-content"
              dangerouslySetInnerHTML={{
                __html:
                  aboutContent.about_business ||
                  'Loading company overview...',
              }}
            />
          </div>
        </div>

   <div className="col-lg-6 col-md-6">
  {aboutContent.about1 && (
    <img
      src={getImageUrl(aboutContent.about1)}
      style={{
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
        borderRadius: '8px'
      }}
      alt="About Hero"
    />
  )}
</div>
      </div>
    </div>
  </div>
</section>

      {/* Company Overview */}
      <section className="section-padding">
        <div className="container">
          <div className="row align-items-center">
           <div className="col-lg-6 col-md-6">
              <h2 className="m-bottom-20">Company Overview</h2>
             
	<div 
                  className="post-content" 
                  dangerouslySetInnerHTML={{ __html: aboutContent.about_company || 'Loading overview...'}} 
                />
              {/* <button className="btn btn-secondary m-top-30"><i className="la la-file"></i> Company Brochure</button> */}
            </div>
        <div className="col-lg-6 col-md-6">
  {aboutContent.about2 && (
    <img
      src={getImageUrl(aboutContent.about2)}
      style={{
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
        borderRadius: '8px'
      }}
      alt="Company Overview"
    />
  )}
</div>
          </div>
        </div>
      </section>

      {/* Key Figures */}
      <div className="counter counter--7 biz_overlay overlay--primary">
        <div className="bg_image_holder" style={{ backgroundImage: 'url("/images/cbg5.webp")' }}></div>
        <div className="container content_above">
          <div className="row align-items-center">
            <div className="col-md-5 margin-md-60 counter_left_content">
              <h4>Key Figures</h4>
            
	<div 
                  className="post-content" 
                  dangerouslySetInnerHTML={{ __html: aboutContent.about_key_figure || 'Loading ...'}} 
                />
            </div>
     
                  <div className="col-md-6 offset-md-1">
            <div className="row">
              <div className="col-sm-6">
                <div className="counter_single">
                  <h3 className="value count_up">{aboutContent.about_usd_revenue}</h3>
                  <p className="title">Total Revenue</p>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="counter_single">
                  <h3 className="value count_up">{aboutContent.about_usd_assets}</h3>
                  <p className="title">INR  Assets</p>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="counter_single">
                  <h3 className="value count_up">{aboutContent.about_total_employees}</h3>
                  <p className="title">Employees</p>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="counter_single">
                  <h3 className="value count_up">{aboutContent.about_usd_net_income}</h3>
                  <p className="title">Total Net Income</p>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>

      {/* Mission & Vision */}
      <section className="section-bg p-top-100 p-bottom-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 margin-md-60">
              <h2 className="m-bottom-20">Startup Business Mission</h2>
              <p>{aboutContent.about_mission || 'Client-focused, leadership, execution, aspiration.'}</p>
              <ul className="arrow--list2 m-top-30">
                <li><i className="la la-angle-right"></i> Client-Focused</li>
                <li><i className="la la-angle-right"></i> Leadership</li>
                <li><i className="la la-angle-right"></i> Execution Excellence</li>
                <li><i className="la la-angle-right"></i> Aspiration</li>
              </ul>
            </div>
            <div className="col-lg-6">
              <h2 className="m-bottom-20">Startup Business Vision</h2>
              <p>{aboutContent.about_vision || 'Innovation, growth, and strategic planning at scale.'}</p>
              <ul className="arrow--list2 m-top-30">
                <li><i className="la la-angle-right"></i> Innovation</li>
                <li><i className="la la-angle-right"></i> Growth Mindset</li>
                <li><i className="la la-angle-right"></i> Strategic Partnerships</li>
                <li><i className="la la-angle-right"></i> Long-Term Impact</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="p-top-100 p-bottom-40">
        <div className="container">
          <h2 className="text-center mb-5">Why Choose Us</h2>
          <div className="row">
            {features.map((feature, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="icon-box-four d-flex">
                  <div className="box-icon"><span className="icon-square-sm"><i className={feature.icon}></i></span></div>
                  <div className="box-content">
                    <h6>{feature.title}</h6>
                    <p>{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Professional Skills */}
      <section className="section-split2 p-top-100 p-bottom-105 section-bg">
        <div className="container">
          <h2 className="text-left">Professional Skills</h2>
          <p>{aboutContent.about_professional_skills || 'Our key strengths that drive success.'}</p>
          {skills.map((skill, index) => (
            <div className="progress-wrapper" key={index}>
              <div className="labels d-flex justify-content-between">
                <span>{skill.name}</span>
                <span>{skill.percentage}%</span>
              </div>
              <div className="progress">
                <div
                  className="progress-bar bg-secondary"
                  style={{ width: `${skill.percentage}%` }}
                  role="progressbar"
                  aria-valuenow={skill.percentage}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      <div style={{ background: '#F9F9F9' }}>
        <Testimonials testimonial={testimonial} />
      </div>

      {/* Team Members */}
      <section className="py-24">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold">Business Experts</h1>
        </div>
        <div className="container mx-auto px-4 bg-white mb-4 shadow-lg rounded-lg p-6">
          <TeamMember />
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default About;
